angular.module('services', []);

require('../services/routerService');
require('../services/dataService');
require('../services/imageGalleryService');
require('../services/termHelper');
require('../services/postMessageService');
require('../services/analyticsService');
